module.exports = __webpack_public_path__ + "26985e82dcc17d300cb9cce49e3280c0.svg";